"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _User = _interopRequireDefault(require("@decisiv/iconix/lib/components/User"));

var _Building = _interopRequireDefault(require("@decisiv/iconix/lib/components/Building"));

var _constants = require("../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function useAvatarIcon(_ref) {
  var entityType = _ref.entityType,
      size = _ref.size;
  return {
    as: entityType === _constants.entityTypes.person ? _User.default : _Building.default,
    size: size
  };
}

var _default = useAvatarIcon;
exports.default = _default;